import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("KHA ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "60vh", display: "grid", placeItems: "center", padding: 24, textAlign: "center", fontFamily: "sans-serif" }}>
          <div>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: "#14161b" }}>Something went wrong</h1>
            <p style={{ color: "#6b7280", marginTop: 8 }}>Please reload the page to continue.</p>
            <button onClick={() => window.location.reload()} style={{ marginTop: 16, background: "#14161b", color: "#fff", border: 0, borderRadius: 999, padding: "10px 20px", cursor: "pointer" }}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
